!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("axios"), require("base-64")) : "function" == typeof define && define.amd ? define(["exports", "axios", "base-64"], e) : e((t = "undefined" != typeof globalThis ? globalThis : t || self).DirectusSDK = {}, t.axios, t.base64);
}(this, function (t, e, o) {
  "use strict";

  function r(t) {
    return t && "object" == typeof t && "default" in t ? t : {
      default: t
    };
  }
  var n = r(e),
    u = function () {
      return (u = Object.assign || function (t) {
        for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
      }).apply(this, arguments);
    },
    i = "directus-sdk-js",
    s = (Object.defineProperty(a.prototype, "token", {
      get: function () {
        return this.internalConfiguration.token;
      },
      set: function (t) {
        this.partialUpdate({
          token: t
        });
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(a.prototype, "tokenExpirationTime", {
      get: function () {
        return this.internalConfiguration.tokenExpirationTime;
      },
      set: function (t) {
        void 0 !== t && this.partialUpdate({
          tokenExpirationTime: 6e4 * t
        });
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(a.prototype, "url", {
      get: function () {
        return this.internalConfiguration.url;
      },
      set: function (t) {
        this.partialUpdate({
          url: t
        });
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(a.prototype, "project", {
      get: function () {
        return this.internalConfiguration.project;
      },
      set: function (t) {
        this.partialUpdate({
          project: t
        });
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(a.prototype, "localExp", {
      get: function () {
        return this.internalConfiguration.localExp;
      },
      set: function (t) {
        this.partialUpdate({
          localExp: t
        });
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(a.prototype, "persist", {
      get: function () {
        return this.internalConfiguration.persist;
      },
      set: function (t) {
        this.internalConfiguration.persist = t;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(a.prototype, "mode", {
      get: function () {
        return this.internalConfiguration.mode;
      },
      set: function (t) {
        this.internalConfiguration.mode = t;
      },
      enumerable: !0,
      configurable: !0
    }), a.prototype.update = function (t) {
      this.internalConfiguration = t, this.hydrate(t);
    }, a.prototype.partialUpdate = function (t) {
      this.internalConfiguration = u({}, this.internalConfiguration, t), this.hydrate(this.internalConfiguration);
    }, a.prototype.reset = function () {
      delete this.internalConfiguration.token, delete this.internalConfiguration.url, delete this.internalConfiguration.project, delete this.internalConfiguration.localExp, this.deleteHydratedConfig();
    }, a.prototype.dehydrate = function () {
      if (this.storage && this.persist) {
        var t = this.storage.getItem(i);
        if (t) {
          var e = JSON.parse(t);
          return this.internalConfiguration = e;
        }
      }
    }, a.prototype.hydrate = function (t) {
      t.storage = void 0, this.storage && this.persist && this.storage.setItem(i, JSON.stringify(t));
    }, a.prototype.deleteHydratedConfig = function () {
      this.storage && this.persist && this.storage.removeItem(i);
    }, a.prototype.dehydratedInitialConfiguration = function (t) {
      if (!t) return {};
      var e = t.getItem(i);
      if (!e) return {};
      try {
        return JSON.parse(e);
      } catch (t) {
        return {};
      }
    }, a.defaults = {
      tokenExpirationTime: 3e4,
      mode: "jwt"
    }, a);
  function a(t, e) {
    void 0 === t && (t = {});
    var r = {};
    (this.storage = e) && Boolean(t && t.persist) && (r = this.dehydratedInitialConfiguration(e));
    var n = Boolean(r.persist || t.persist),
      o = r.project || t.project,
      i = r.mode || t.mode || a.defaults.mode,
      s = r.tokenExpirationTime || t.tokenExpirationTime || a.defaults.tokenExpirationTime;
    this.internalConfiguration = u({}, t, r, {
      persist: n,
      mode: i,
      project: o,
      tokenExpirationTime: s
    });
  }
  function p(t) {
    return t.startsWith("directus_") ? "/" + t.substr(9) : "/items/" + t;
  }
  function c(t) {
    return t && "string" == typeof t && /\S/.test(t);
  }
  function l(t) {
    return function (t, e) {
      return Object.prototype.toString.call(e) === "[object " + t + "]";
    }("Number", t) && isFinite(t) && !isNaN(parseFloat(t));
  }
  function f(t) {
    return t instanceof Function;
  }
  var h = function (t, e) {
    return t + "=" + encodeURIComponent(e);
  };
  function d(t, e, r) {
    void 0 === r && (r = h);
    var n,
      o = [];
    for (n in t) if (t.hasOwnProperty(n)) {
      var i = e ? e + "[" + n + "]" : n,
        s = t[n];
      o.push(null !== s && "object" == typeof s ? d(s, i) : r(i, s));
    }
    return o.join("&");
  }
  function g(t) {
    if (!t || t.length < 0 || t.split(".").length <= 0) return {};
    try {
      var e = t.split(".")[1].replace("-", "+").replace("_", "/"),
        r = o.decode(e),
        n = JSON.parse(r);
      return l(n.exp) && (n.exp = new Date(1e3 * n.exp)), n;
    } catch (t) {
      return {};
    }
  }
  var y = function (i, s, u, a) {
      return new (u = u || Promise)(function (t, e) {
        function r(t) {
          try {
            o(a.next(t));
          } catch (t) {
            e(t);
          }
        }
        function n(t) {
          try {
            o(a.throw(t));
          } catch (t) {
            e(t);
          }
        }
        function o(e) {
          e.done ? t(e.value) : new u(function (t) {
            t(e.value);
          }).then(r, n);
        }
        o((a = a.apply(i, s || [])).next());
      });
    },
    v = function (r, n) {
      var o,
        i,
        s,
        t,
        u = {
          label: 0,
          sent: function () {
            if (1 & s[0]) throw s[1];
            return s[1];
          },
          trys: [],
          ops: []
        };
      return t = {
        next: e(0),
        throw: e(1),
        return: e(2)
      }, "function" == typeof Symbol && (t[Symbol.iterator] = function () {
        return this;
      }), t;
      function e(e) {
        return function (t) {
          return function (e) {
            if (o) throw new TypeError("Generator is already executing.");
            for (; u;) try {
              if (o = 1, i && (s = 2 & e[0] ? i.return : e[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, e[1])).done) return s;
              switch (i = 0, s && (e = [2 & e[0], s.value]), e[0]) {
                case 0:
                case 1:
                  s = e;
                  break;
                case 4:
                  return u.label++, {
                    value: e[1],
                    done: !1
                  };
                case 5:
                  u.label++, i = e[1], e = [0];
                  continue;
                case 7:
                  e = u.ops.pop(), u.trys.pop();
                  continue;
                default:
                  if (!(s = 0 < (s = u.trys).length && s[s.length - 1]) && (6 === e[0] || 2 === e[0])) {
                    u = 0;
                    continue;
                  }
                  if (3 === e[0] && (!s || e[1] > s[0] && e[1] < s[3])) {
                    u.label = e[1];
                    break;
                  }
                  if (6 === e[0] && u.label < s[1]) {
                    u.label = s[1], s = e;
                    break;
                  }
                  if (s && u.label < s[2]) {
                    u.label = s[2], u.ops.push(e);
                    break;
                  }
                  s[2] && u.ops.pop(), u.trys.pop();
                  continue;
              }
              e = n.call(r, u);
            } catch (t) {
              e = [6, t], i = 0;
            } finally {
              o = s = 0;
            }
            if (5 & e[0]) throw e[1];
            return {
              value: e[0] ? e[1] : void 0,
              done: !0
            };
          }([e, t]);
        };
      }
    },
    m = (b.prototype.login = function (t, e) {
      var r = this;
      this.config.token = void 0, t.url && c(t.url) && (this.config.url = t.url), t.project && c(t.project) && (this.config.project = t.project), e && c(e.mode) && (this.config.mode = e.mode), (t.persist || e && e.persist || this.config.persist) && this.startInterval();
      var n = {
        email: t.email,
        password: t.password,
        mode: "jwt"
      };
      "cookie" === this.config.mode && (n.mode = "cookie"), t.otp && (n.otp = t.otp);
      var o = this.inject.post("/auth/authenticate", n);
      return "jwt" === this.config.mode && o.then(function (t) {
        return r.config.token = t.data.token, t;
      }).then(function (t) {
        return r.config.token = t.data.token, r.config.localExp = new Date(Date.now() + (r.config.tokenExpirationTime || 0)).getTime(), t;
      }), o;
    }, b.prototype.logout = function () {
      return y(this, void 0, void 0, function () {
        var e;
        return v(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.inject.request("post", "/auth/logout", {}, {}, !1)];
            case 1:
              return e = t.sent(), this.config.token = void 0, this.refreshInterval && this.stopInterval(), [2, e];
          }
        });
      });
    }, b.prototype.refreshIfNeeded = function () {
      var r = this,
        t = this.getPayload(),
        e = this.config,
        n = e.token,
        o = e.localExp;
      if (c(n) && t && t.exp) {
        var i = (o || 0) - Date.now();
        if (!(i <= 0)) return i < 3e4 ? new Promise(function (e) {
          n && r.refresh(n).then(function (t) {
            r.config.localExp = new Date(Date.now() + (r.config.tokenExpirationTime || 0)).getTime(), r.config.token = t.data.token || n, f(r.onAutoRefreshSuccess) && r.onAutoRefreshSuccess(r.config), e([!0]);
          }).catch(function (t) {
            f(r.onAutoRefreshError) && r.onAutoRefreshError(t), e([!0, t]);
          });
        }) : void 0;
        f(this.onAutoRefreshError) && this.onAutoRefreshError({
          code: 102,
          message: "auth_expired_token"
        });
      }
    }, b.prototype.refresh = function (t) {
      return this.inject.post("/auth/refresh", {
        token: t
      });
    }, b.prototype.startInterval = function (t) {
      t && this.refreshIfNeeded(), this.refreshInterval = setInterval(this.refreshIfNeeded.bind(this), 1e4);
    }, b.prototype.stopInterval = function () {
      clearInterval(this.refreshInterval), this.refreshInterval = void 0;
    }, b.prototype.getPayload = function () {
      return c(this.config.token) ? g(this.config.token) : null;
    }, b);
  function b(t, e) {
    this.config = t, this.inject = e, t.token && t.token.includes(".") && this.startInterval(!0);
  }
  function w(t, e) {
    if (void 0 === e && (e = 10), e < 1) throw new Error("ConcurrencyManager Error: minimun concurrent requests is 1");
    var r = {
      queue: [],
      running: [],
      interceptors: {
        request: 0,
        response: 0
      },
      shiftInitial: function () {
        setTimeout(function () {
          r.running.length < e && r.shift();
        }, 0);
      },
      push: function (t) {
        r.queue.push(t), r.shiftInitial();
      },
      shift: function () {
        if (r.queue.length) {
          var t = r.queue.shift();
          t && (t.resolver(t.request), r.running.push(t));
        }
      },
      requestHandler: function (e) {
        return new Promise(function (t) {
          r.push({
            request: e,
            resolver: t
          });
        });
      },
      responseHandler: function (t) {
        return r.running.shift(), r.shift(), t;
      },
      responseErrorHandler: function (t) {
        return Promise.reject(r.responseHandler(t));
      },
      detach: function () {
        t.interceptors.request.eject(r.interceptors.request), t.interceptors.response.eject(r.interceptors.response);
      }
    };
    return r.interceptors.request = t.interceptors.request.use(r.requestHandler), r.interceptors.response = t.interceptors.response.use(r.responseHandler, r.responseErrorHandler), r;
  }
  var j,
    k,
    P = (j = function (t, e) {
      return (j = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
      })(t, e);
    }, function (t, e) {
      function r() {
        this.constructor = t;
      }
      j(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
    }),
    x = function () {
      return (x = Object.assign || function (t) {
        for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
      }).apply(this, arguments);
    },
    q = (k = Error, P(I, k), Object.defineProperty(I.prototype, "url", {
      get: function () {
        return this.info.url;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(I.prototype, "method", {
      get: function () {
        return this.info.method.toUpperCase();
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(I.prototype, "code", {
      get: function () {
        return "" + (this.info.code || -1);
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(I.prototype, "params", {
      get: function () {
        return this.info.params || {};
      },
      enumerable: !0,
      configurable: !0
    }), I.prototype.toString = function () {
      return ["Directus call failed:", this.method + " " + this.url + " " + JSON.stringify(this.params) + " -", this.message, "(code " + this.code + ")"].join(" ");
    }, I);
  function I(t, e) {
    var r = this.constructor,
      n = k.call(this, t) || this;
    return n.message = t, n.info = e, Object.setPrototypeOf(n, r.prototype), n;
  }
  var C = (O.prototype.reset = function () {
    this.auth.logout(), this.config.deleteHydratedConfig();
  }, O.prototype.get = function (t, e) {
    return void 0 === e && (e = {}), this.request("get", t, e);
  }, O.prototype.post = function (t, e, r) {
    return void 0 === e && (e = {}), void 0 === r && (r = {}), this.request("post", t, r, e);
  }, O.prototype.patch = function (t, e, r) {
    return void 0 === e && (e = {}), void 0 === r && (r = {}), this.request("patch", t, r, e);
  }, O.prototype.put = function (t, e, r) {
    return void 0 === e && (e = {}), void 0 === r && (r = {}), this.request("put", t, r, e);
  }, O.prototype.delete = function (t) {
    return this.request("delete", t);
  }, O.prototype.getPayload = function () {
    return c(this.config.token) ? g(this.config.token) : null;
  }, O.prototype.request = function (t, e, r, n, o, i, s) {
    if (void 0 === r && (r = {}), void 0 === o && (o = !1), void 0 === i && (i = {}), void 0 === s && (s = !1), !this.config.url) throw new Error("SDK has no URL configured to send requests to, please check the docs.");
    if (!1 === o && !this.config.project) throw new Error("SDK has no project configured to send requests to, please check the docs.");
    var u = "" + this.config.url;
    !1 === u.endsWith("/") && (u += "/"), !1 === o && (u += this.config.project + "/");
    var a = {
      baseURL: u,
      data: n,
      headers: i,
      method: t,
      params: r,
      url: e
    };
    return this.config.token && c(this.config.token) && 0 < this.config.token.length && (a.headers = i, a.headers.Authorization = "Bearer " + this.config.token), this.config.project && (a.headers["X-Directus-Project"] = this.config.project), this.xhr.request(a).then(function (t) {
      return t.data;
    }).then(function (e) {
      if (!e || 0 === e.length) return e;
      if ("object" != typeof e) try {
        return s ? e : JSON.parse(e);
      } catch (t) {
        throw {
          data: e,
          error: t,
          json: !0
        };
      }
      return e;
    }).catch(function (t) {
      var e = (t && t.response || {}).data || {},
        r = {
          error: t,
          url: a.url,
          method: a.method,
          params: a.params,
          code: e.error && (e.error.code || t.code) || -1
        };
      throw t && t.response && e.error ? new q(e.error.message || "Unknown error occured", r) : t.response && !0 === t.response.json ? new q("API returned invalid JSON", x({}, r, {
        code: 422
      })) : new q("Network error", x({}, r, {
        code: -1
      }));
    });
  }, O);
  function O(t) {
    var e = {
      paramsSerializer: d,
      timeout: 6e5,
      withCredentials: !1
    };
    "cookie" === (this.config = t).mode && (e.withCredentials = !0), this.xhr = n.default.create(e), this.auth = new m(t, {
      post: this.post.bind(this),
      xhr: this.xhr,
      request: this.request.bind(this)
    }), this.concurrent = w(this.xhr, 10);
  }
  var _ = function (i, s, u, a) {
      return new (u = u || Promise)(function (t, e) {
        function r(t) {
          try {
            o(a.next(t));
          } catch (t) {
            e(t);
          }
        }
        function n(t) {
          try {
            o(a.throw(t));
          } catch (t) {
            e(t);
          }
        }
        function o(e) {
          e.done ? t(e.value) : new u(function (t) {
            t(e.value);
          }).then(r, n);
        }
        o((a = a.apply(i, s || [])).next());
      });
    },
    E = function (r, n) {
      var o,
        i,
        s,
        t,
        u = {
          label: 0,
          sent: function () {
            if (1 & s[0]) throw s[1];
            return s[1];
          },
          trys: [],
          ops: []
        };
      return t = {
        next: e(0),
        throw: e(1),
        return: e(2)
      }, "function" == typeof Symbol && (t[Symbol.iterator] = function () {
        return this;
      }), t;
      function e(e) {
        return function (t) {
          return function (e) {
            if (o) throw new TypeError("Generator is already executing.");
            for (; u;) try {
              if (o = 1, i && (s = 2 & e[0] ? i.return : e[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, e[1])).done) return s;
              switch (i = 0, s && (e = [2 & e[0], s.value]), e[0]) {
                case 0:
                case 1:
                  s = e;
                  break;
                case 4:
                  return u.label++, {
                    value: e[1],
                    done: !1
                  };
                case 5:
                  u.label++, i = e[1], e = [0];
                  continue;
                case 7:
                  e = u.ops.pop(), u.trys.pop();
                  continue;
                default:
                  if (!(s = 0 < (s = u.trys).length && s[s.length - 1]) && (6 === e[0] || 2 === e[0])) {
                    u = 0;
                    continue;
                  }
                  if (3 === e[0] && (!s || e[1] > s[0] && e[1] < s[3])) {
                    u.label = e[1];
                    break;
                  }
                  if (6 === e[0] && u.label < s[1]) {
                    u.label = s[1], s = e;
                    break;
                  }
                  if (s && u.label < s[2]) {
                    u.label = s[2], u.ops.push(e);
                    break;
                  }
                  s[2] && u.ops.pop(), u.trys.pop();
                  continue;
              }
              e = n.call(r, u);
            } catch (t) {
              e = [6, t], i = 0;
            } finally {
              o = s = 0;
            }
            if (5 & e[0]) throw e[1];
            return {
              value: e[0] ? e[1] : void 0,
              done: !0
            };
          }([e, t]);
        };
      }
    },
    S = (T.prototype.login = function (t, e) {
      return this.api.auth.login(t, e);
    }, T.prototype.logout = function () {
      return this.api.auth.logout();
    }, T.prototype.reset = function () {
      this.api.reset();
    }, T.prototype.refreshIfNeeded = function () {
      return this.api.auth.refreshIfNeeded();
    }, T.prototype.refresh = function (t) {
      return this.api.auth.refresh(t);
    }, T.prototype.requestPasswordReset = function (t, e) {
      var r = {
        email: t
      };
      return e && (r.reset_url = e), this.api.post("/auth/password/request", r);
    }, T.prototype.resetPassword = function (t, e) {
      var r = {
        password: t,
        token: e
      };
      return this.api.post("/auth/password/reset", r);
    }, T.prototype.getActivity = function (t) {
      return void 0 === t && (t = {}), this.api.get("/activity", t);
    }, T.prototype.getMyBookmarks = function (t) {
      return void 0 === t && (t = {}), this.getCollectionPresets(t);
    }, T.prototype.getCollections = function (t) {
      return void 0 === t && (t = {}), this.api.get("/collections", t);
    }, T.prototype.getCollection = function (t, e) {
      return void 0 === e && (e = {}), this.api.get("/collections/" + t, e);
    }, T.prototype.createCollection = function (t) {
      return this.api.post("/collections", t);
    }, T.prototype.updateCollection = function (t, e) {
      return this.api.patch("/collections/" + t, e);
    }, T.prototype.deleteCollection = function (t) {
      return this.api.delete("/collections/" + t);
    }, T.prototype.getCollectionPresets = function (t) {
      return _(this, void 0, void 0, function () {
        var e, r, n;
        return E(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.getMe({
                fields: "*.*"
              })];
            case 1:
              return e = t.sent().data, r = e.id, n = e.role.id, [2, Promise.all([this.api.get("/collection_presets", {
                "filter[title][nnull]": 1,
                "filter[user][eq]": r
              }), this.api.get("/collection_presets", {
                "filter[role][eq]": n,
                "filter[title][nnull]": 1,
                "filter[user][null]": 1
              }), this.api.get("/collection_presets", {
                "filter[role][null]": 1,
                "filter[title][nnull]": 1,
                "filter[user][null]": 1
              })]).then(function (t) {
                var e = t[0],
                  r = t[1],
                  n = t[2];
                return (e.data || []).concat(r.data || [], n.data || []);
              })];
          }
        });
      });
    }, T.prototype.createCollectionPreset = function (t) {
      return this.api.post("/collection_presets", t);
    }, T.prototype.updateCollectionPreset = function (t, e) {
      return this.api.patch("/collection_presets/" + t, e);
    }, T.prototype.deleteCollectionPreset = function (t) {
      return this.api.delete("/collection_presets/" + t);
    }, T.prototype.getInterfaces = function () {
      return this.api.request("get", "/interfaces", {}, {}, !0);
    }, T.prototype.getLayouts = function () {
      return this.api.request("get", "/layouts", {}, {}, !0);
    }, T.prototype.getModules = function () {
      return this.api.request("get", "/modules", {}, {}, !0);
    }, T.prototype.getAllFields = function (t) {
      return void 0 === t && (t = {}), this.api.get("/fields", t);
    }, T.prototype.getFields = function (t, e) {
      return void 0 === e && (e = {}), this.api.get("/fields/" + t, e);
    }, T.prototype.getField = function (t, e, r) {
      return void 0 === r && (r = {}), this.api.get("/fields/" + t + "/" + e, r);
    }, T.prototype.createField = function (t, e) {
      return this.api.post("/fields/" + t, e);
    }, T.prototype.updateField = function (t, e, r) {
      return this.api.patch("/fields/" + t + "/" + e, r);
    }, T.prototype.updateFields = function (t, e, r) {
      return void 0 === r && (r = null), r ? this.api.patch("/fields/" + t + "/" + e.join(","), r) : this.api.patch("/fields/" + t, e);
    }, T.prototype.deleteField = function (t, e) {
      return this.api.delete("/fields/" + t + "/" + e);
    }, T.prototype.getAssetUrl = function (t, e) {
      var r = e ? d(e) : "",
        n = [this.config.url.replace(/\/$/, ""), this.config.project, "assets", t].join("/");
      return 0 < r.length ? n + "?" + r : n;
    }, T.prototype.getAsset = function (n, o) {
      return _(this, void 0, void 0, function () {
        var e, r;
        return E(this, function (t) {
          return e = this.api.xhr.defaults.responseType, this.api.xhr.defaults.responseType = "arraybuffer", r = this.api.request("get", "/assets/" + n, o, void 0, !1, void 0, !0), this.api.xhr.defaults.responseType = e, [2, r];
        });
      });
    }, T.prototype.getFiles = function (e) {
      return void 0 === e && (e = {}), _(this, void 0, void 0, function () {
        return E(this, function (t) {
          return [2, this.api.get("/files", e)];
        });
      });
    }, T.prototype.getFile = function (r, n) {
      return void 0 === n && (n = {}), _(this, void 0, void 0, function () {
        var e;
        return E(this, function (t) {
          return e = "string" == typeof r ? r : r.join(","), [2, this.api.get("/files/" + e, n)];
        });
      });
    }, T.prototype.uploadFiles = function (n, o) {
      return void 0 === o && (o = function () {
        return {};
      }), _(this, void 0, void 0, function () {
        var e, r;
        return E(this, function (t) {
          switch (t.label) {
            case 0:
              return !1 === (e = "" + this.config.url).endsWith("/") && (e += "/"), e += this.config.project, r = {
                "Content-Type": "multipart/form-data",
                "X-Directus-Project": this.config.project
              }, this.config.token && c(this.config.token) && 0 < this.config.token.length && (r.Authorization = "Bearer " + this.config.token), [4, this.api.xhr({
                method: "post",
                url: "/files",
                baseURL: e,
                data: n,
                headers: r,
                onUploadProgress: o,
                withCredentials: !0
              })];
            case 1:
              return [2, t.sent().data];
          }
        });
      });
    }, T.prototype.updateItem = function (t, e, r, n) {
      void 0 === n && (n = {});
      var o = p(t);
      return this.api.patch(o + "/" + e, r, n);
    }, T.prototype.updateItems = function (t, e, r) {
      void 0 === r && (r = {});
      var n = p(t);
      return this.api.patch(n, e, r);
    }, T.prototype.createItem = function (t, e) {
      var r = p(t);
      return this.api.post(r, e);
    }, T.prototype.createItems = function (t, e) {
      var r = p(t);
      return this.api.post(r, e);
    }, T.prototype.getItems = function (t, e) {
      void 0 === e && (e = {});
      var r = p(t);
      return this.api.get(r, e);
    }, T.prototype.getItem = function (t, e, r) {
      void 0 === r && (r = {});
      var n = p(t);
      return this.api.get(n + "/" + e, r);
    }, T.prototype.deleteItem = function (t, e) {
      var r = p(t);
      return this.api.delete(r + "/" + e);
    }, T.prototype.deleteItems = function (t, e) {
      var r = p(t);
      return this.api.delete(r + "/" + e.join());
    }, T.prototype.getMyListingPreferences = function (o, t) {
      return _(this, void 0, void 0, function () {
        var e, r, n;
        return E(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.getMe({
                fields: "*.*"
              })];
            case 1:
              return e = t.sent().data, r = e.id, n = e.role.id, [2, Promise.all([this.api.get("/collection_presets", {
                "filter[collection][eq]": o,
                "filter[role][null]": 1,
                "filter[title][null]": 1,
                "filter[user][null]": 1,
                limit: 1,
                sort: "-id"
              }), this.api.get("/collection_presets", {
                "filter[collection][eq]": o,
                "filter[role][eq]": n,
                "filter[title][null]": 1,
                "filter[user][null]": 1,
                limit: 1,
                sort: "-id"
              }), this.api.get("/collection_presets", {
                "filter[collection][eq]": o,
                "filter[title][null]": 1,
                "filter[user][eq]": r,
                limit: 1,
                sort: "-id"
              })]).then(function (t) {
                var e = t[0],
                  r = t[1],
                  n = t[2];
                return n.data && 0 < n.data.length ? n.data[0] : r.data && 0 < r.data.length ? r.data[0] : e.data && 0 < e.data.length ? e.data[0] : {};
              })];
          }
        });
      });
    }, T.prototype.getPermissions = function (t) {
      return void 0 === t && (t = {}), this.getItems("directus_permissions", t);
    }, T.prototype.getMyPermissions = function (t) {
      return void 0 === t && (t = {}), this.api.get("/permissions/me", t);
    }, T.prototype.createPermissions = function (t) {
      return this.api.post("/permissions", t);
    }, T.prototype.updatePermissions = function (t) {
      return this.api.patch("/permissions", t);
    }, T.prototype.getRelations = function (t) {
      return void 0 === t && (t = {}), this.api.get("/relations", t);
    }, T.prototype.createRelation = function (t) {
      return this.api.post("/relations", t);
    }, T.prototype.updateRelation = function (t, e) {
      return this.api.patch("/relations/" + t, e);
    }, T.prototype.getCollectionRelations = function (t, e) {
      return Promise.all([this.api.get("/relations", {
        "filter[collection_many][eq]": t
      }), this.api.get("/relations", {
        "filter[collection_one][eq]": t
      })]);
    }, T.prototype.getItemRevisions = function (t, e, r) {
      void 0 === r && (r = {});
      var n = p(t);
      return this.api.get(n + "/" + e + "/revisions", r);
    }, T.prototype.revert = function (t, e, r) {
      var n = p(t);
      return this.api.patch(n + "/" + e + "/revert/" + r);
    }, T.prototype.getRole = function (t, e) {
      return void 0 === e && (e = {}), this.api.get("/roles/" + t, e);
    }, T.prototype.getRoles = function (t) {
      return void 0 === t && (t = {}), this.api.get("/roles", t);
    }, T.prototype.updateRole = function (t, e) {
      return this.updateItem("directus_roles", t, e);
    }, T.prototype.createRole = function (t) {
      return this.createItem("directus_roles", t);
    }, T.prototype.deleteRole = function (t) {
      return this.deleteItem("directus_roles", t);
    }, T.prototype.getSettings = function (t) {
      return void 0 === t && (t = {}), t.limit = -1, this.api.get("/settings", t);
    }, T.prototype.getSettingsFields = function (t) {
      return void 0 === t && (t = {}), this.api.get("/settings/fields", t);
    }, T.prototype.getUsers = function (t) {
      return void 0 === t && (t = {}), this.api.get("/users", t);
    }, T.prototype.getUser = function (t, e) {
      return void 0 === e && (e = {}), this.api.get("/users/" + t, e);
    }, T.prototype.getMe = function (t) {
      return void 0 === t && (t = {}), this.api.get("/users/me", t);
    }, T.prototype.createUser = function (t) {
      return this.api.post("/users", t);
    }, T.prototype.updateUser = function (t, e) {
      return this.updateItem("directus_users", t, e);
    }, T.prototype.updateDatabase = function () {
      return this.api.post("/update");
    }, T.prototype.ping = function () {
      return this.api.request("get", "/server/ping", {}, {}, !0, {}, !0);
    }, T.prototype.serverInfo = function () {
      return this.api.request("get", "/", {}, {}, !0);
    }, T.prototype.projectInfo = function () {
      return this.api.request("get", "/");
    }, T.prototype.getThirdPartyAuthProviders = function () {
      return this.api.get("/auth/sso");
    }, T.prototype.isLoggedIn = function () {
      var t = this;
      return new Promise(function (e) {
        t.api.get("/").then(function (t) {
          return void 0 === t.public ? e(!0) : e(!1);
        }).catch(function () {
          return e(!1);
        });
      });
    }, T);
  function T(t) {
    this.config = new s(t, t ? t.storage : void 0), this.api = new C(this.config);
  }
  t.Configuration = s, t.SDK = S, t.concurrencyManager = w, t.default = S, t.getCollectionItemPath = p, t.getPayload = g, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});